import React, { FC } from 'react';
import styled from 'styled-components';
import {
  BROWSER_BREAKPOINTS,
  DetailsItem,
  DetailsWrapper,
  TagsView,
  Typography
} from '@flicent/fieldpulse-react-component-library-frontend';

import JobDetailsProps from './JobDetails.props';


const StyledRoot = styled.div`
  display: grid;
  grid-row-gap: 40px;

  @media screen and ${ BROWSER_BREAKPOINTS.MOBILE } {
    grid-row-gap: 20px;
  }
`;

const JobDetails: FC<JobDetailsProps> = ({ job }) => {
  return (
    <StyledRoot>
      <Typography variant="h1" color="blue">{ job.title }</Typography>

      { job.is_job_details_visible && <DetailsWrapper>
        <DetailsItem label="Job Tags" value={ job.tags.length ? <TagsView tags={ job.tags }/> : null }/>
        <DetailsItem label="Date/Time" value={ job.display_time }/>
        <DetailsItem label="Location" value={ job.location }/>
        <DetailsItem label="Status" value={ job.status_name }/>
        { job.is_job_location_title_visible && <DetailsItem label="Location Name" value={ job.location_title }/> }
        <DetailsItem label="Assigned Team Members" value={ job.members }/>
      </DetailsWrapper> }
    </StyledRoot>
  );
};


export default JobDetails;